import {TopPathsFlowStep} from './top-paths-flow-step';

type StepType = {
  conversionRate?: number;
  event?: string;
  segments?: any[];
  totalCount?: number;
  type?: string;
  index?: number;
};
export class TopPathsFlow {
  private steps: TopPathsFlowStep[];

  constructor({flowSteps}) {
    const steps: StepType[] = (
      flowSteps || []
    ).map(
      (
        step: Array<{conversionRate?: number; event?: string; segments?: any[]; totalCount?: number; type?: string}>,
        index: number,
      ) => ({...step, index}),
    );
    const contiguousSteps: StepType[] = this.getContiguousSteps(steps);

    contiguousSteps.forEach((step: StepType, index: number, source: string | any[]) => {
      const nextStep = index < source.length - 1 ? source[index + 1] : null;

      if (nextStep) {
        steps[step.index].conversionRate = Number(nextStep.totalCount) / Number(step.totalCount);
      }
    });

    this.steps = steps.map(
      (step: {conversionRate?: number; event?: string; segments?: any[]; totalCount?: number; type?: string}) =>
        new TopPathsFlowStep(step),
    );
  }

  get isEmpty() {
    return this.steps.length === 0 || this.steps.every((step) => step.isEmpty);
  }

  getContiguousSteps(steps: StepType[] = []): TopPathsFlowStep[] | StepType[] {
    let finalSteps: TopPathsFlowStep[] | StepType[] = [];
    if (steps?.length > 1) {
      finalSteps = steps?.filter((step: StepType) => step.type !== `EMPTY`);
    } else if (this.steps?.length > 1) {
      finalSteps = this.steps?.filter((step: TopPathsFlowStep) => step.type !== `EMPTY`);
    }
    return finalSteps;
  }

  getSteps(): TopPathsFlowStep[] {
    return this.steps;
  }
}
